 let restUrl = 'http://192.168.1.40:9093';
 let loginUrl='http://192.168.1.168:8081';
export { restUrl,loginUrl }



//////////////////
// WEBPACK FOOTER
// ./url.js
// module id = 41K4
// module chunks = 1